export default {
  'llm.callLogs.source': '実行元',
  'llm.callLogs.officialSource': '公式サービス',
  'llm.callLogs.tenantSource': 'テナント独自モデル',
  'llm.callLogs.localSource': 'その他のローカルサービス',
  'llm.callLogs.syncPending':
    '公式データは同期中か利用できません。保存済みの記録を表示しています。',
  'llm.callLogs.lastSynced': '公式データの最終同期',
  'llm.callLogs.officialUnavailable':
    '公式の本文は一時的に利用できません。後ほど再試行してください。',
  'llm.callLogs.app': 'アプリ',
  'llm.callLogs.scene': 'シーン',
  'llm.callLogs.caller': '呼び出し元',
  'llm.callLogs.resource': 'リソースID',
  'llm.callLogs.running': '実行中',
  'llm.callLogs.cancelled': 'キャンセル済み',
  'llm.callLogs.unknown': '結果不明',
  'llm.callLogs.notProvided': '未提供',
  'llm.callLogs.estimated': '推定',
  'llm.callLogs.serviceType': 'サービスタイプ',
  'llm.callLogs.actions': '操作',
  'llm.callLogs.details': '呼び出し詳細',
  'llm.callLogs.viewDetails': '詳細を見る',
  'llm.callLogs.detailFailed': '詳細を読み込めませんでした',
  'llm.callLogs.complete': '完全',
  'llm.callLogs.truncated': '切り詰め済み',
  'llm.callLogs.notCaptured': '未収集',
  'llm.callLogs.expired': '期限切れ',
  'llm.callLogs.expiredBody': '本文は30日間の保存期間を過ぎています',
  'llm.callLogs.retry': '再試行',
  'llm.callLogs.incomplete':
    '呼び出しは完了していません。収集済みの内容を表示しています',
  'llm.callLogs.status': '状態',
  'llm.callLogs.entryPoint': '呼び出し元',
  'llm.callLogs.startedAt': '開始時刻',
  'llm.callLogs.endedAt': '終了時刻',
  'llm.callLogs.duration': '合計時間',
  'llm.callLogs.firstResponse': '最初の応答までの時間',
  'llm.callLogs.upstreamId': '上流 Request ID',
  'llm.callLogs.streaming': 'ストリーミング',
  'llm.callLogs.yes': 'はい',
  'llm.callLogs.no': 'いいえ',
  'llm.callLogs.requestBody': 'リクエスト本文',
  'llm.callLogs.responseBody': 'レスポンス本文',
  'llm.callLogs.usage': '使用量と費用',
  'llm.callLogs.inputTokens': '入力トークン',
  'llm.callLogs.outputTokens': '出力トークン',
  'llm.callLogs.totalTokens': '合計トークン',
  'llm.callLogs.cacheReadTokens': 'キャッシュ読み取りトークン',
  'llm.callLogs.cacheWriteTokens': 'キャッシュ書き込みトークン',
  'llm.callLogs.cacheWrite1hTokens': '1時間キャッシュ書き込みトークン',
  'llm.callLogs.reasoningTokens': '推論トークン',
  'llm.callLogs.usageSource': '使用量の取得元',
  'llm.callLogs.meter': '計量',
  'llm.callLogs.cost': '費用',
  'llm.callLogs.settlement': '精算額',
  'llm.callLogs.errorsAndAttempts': 'エラーと試行',
  'llm.callLogs.errorCode': 'エラーコード',
  'llm.callLogs.failedStage': '失敗段階',
  'llm.callLogs.errorMessage': 'エラーメッセージ',
  'llm.callLogs.related': '関連する呼び出し',
  'llm.callLogs.modelService': 'モデル',
  'llm.callLogs.digitalHuman': 'デジタルヒューマン',
  'llm.callLogs.loadFailed':
    'ログの読み込みに失敗しました。再試行してください。',
  'llm.callLogs.requestIdHint': '完全な Request ID を入力（完全一致）',
  'llm.callLogs.scope': '表示範囲',
  'llm.callLogs.modelCode': 'モデルコードを入力',
  'llm.callLogs.sceneCode': 'シーンコードを入力',
  'llm.callLogs.reset': 'リセット',
  'llm.callLogs.search': '検索',
  'llm.callLogs.collapse': '詳細検索を閉じる',
  'llm.callLogs.advanced': '詳細検索',
  'llm.callLogs.retentionHint':
    '既定では保存中の全ログを検索します。すべての条件に一致する結果を表示します。',
  'pages.navigation.items.modelCallLogs': 'プラットフォーム呼び出しログ',
  'llm.callLogs.officialLogs': 'プラットフォーム呼び出しログ',
  'llm.callLogs.tenant': 'テナント',
  'llm.callLogs.refresh': '更新',
  'pages.navigation.items.aiScenes': 'アプリケーションシーン',
  'pages.navigation.items.modelPolicies': '実行ポリシー',
  'pages.navigation.items.modelCircuits': 'サーキットブレーカー',

  'menu.centers.aiModels': 'AIモデル',
  'pages.navigation.items.modelAccess': 'モデル接続',
  'pages.navigation.items.modelUsage': 'プラットフォーム全体の使用量',
  'pages.navigation.items.modelTenantUsage': 'テナント使用量管理',

  'menu.centers.workspace': 'ホーム',
  'menu.centers.applications': 'アプリ',
  'menu.centers.capabilities': 'サービス',
  'menu.centers.markets': 'マーケット',
  'menu.centers.resources': '運用',
  'menu.centers.commercial': '営業',
  'menu.centers.management': 'テナント',
  'menu.centers.settings': '設定',
  'menu.centers.resourceOverview': 'リソース概要',
  'pages.navigation.mainNavigation': 'メインナビゲーション',
  'pages.navigation.skipToContent': 'メインコンテンツに移動',
  'pages.navigation.resizeSidebar': 'サイドバーの幅を調整',
  'pages.navigation.items.appMarket': 'アプリマーケット',
  'pages.navigation.items.skillMarketplace': 'Skill マーケット',
  'pages.navigation.items.mcpMarketplace': 'MCP マーケット',
  'pages.navigation.items.pluginMarketplace': 'プラグインマーケット',
  'pages.navigation.items.workspaceOverview': 'ワークスペース概要',
  'pages.navigation.items.agentApps': 'エージェント管理',
  'pages.navigation.items.models': 'モデル広場',
  'pages.navigation.items.events': 'イベントエンジン',
  'pages.navigation.items.mcp': 'MCP サービス',
  'pages.navigation.items.resourceOverview': 'リソース概要',
  'pages.navigation.items.clusters': 'クラスタ管理',
  'pages.navigation.items.storage': 'アプリストレージ',
  'pages.navigation.items.knowledge': 'ナレッジベース',
  'pages.navigation.items.dataSources': 'データソース',
  'pages.navigation.items.applicationManagement': 'アプリ管理',
  'pages.navigation.items.applications': '業務アプリ',
  'pages.navigation.items.pluginApplications': 'プラグインアプリ',
  'pages.navigation.items.applicationFeedback': 'アプリのフィードバック',
  'pages.navigation.items.externalPublication': '外部アプリの公開',
  'pages.navigation.items.publicationReview': '公開審査',
  'pages.navigation.items.taxonomies': '分類管理',
  'pages.navigation.items.aiServices': 'AI サービス',
  'pages.navigation.items.digitalHumanMarket': 'デジタルヒューマン',
  'pages.navigation.items.digitalHumanMarketplace': 'デジタルヒューマン市場',
  'pages.navigation.items.mcpMarket': 'MCP',
  'pages.navigation.items.skillMarket': 'Skills',
  'pages.navigation.items.products': '商品カタログ',
  'pages.navigation.items.packages': 'プラン管理',
  'pages.navigation.items.entitlements': 'テナント権限',
  'pages.navigation.items.platformTenants': 'テナント管理',
  'pages.navigation.items.platformUsers': 'ユーザー管理',
  'pages.navigation.items.platformPermissions': 'プラットフォーム権限',
  'pages.navigation.items.platformSettings': 'プラットフォーム設定',
  'pages.navigation.items.orders': '決済注文',
  'pages.navigation.items.members': 'メンバー管理',
  'pages.navigation.items.departments': '部門管理',
  'pages.navigation.items.roles': 'アクセス権管理',
  'pages.navigation.items.auditLog': '監査ログ',
  'menu.centers.appStore': 'デプロイテンプレート',
  'menu.centers.deployments': 'マイデプロイ',
  'pages.navigation.items.appStore': 'デプロイテンプレート',
  'pages.navigation.items.deployments': 'マイデプロイ',
  'menu.centers.images': 'イメージレジストリ',
  'pages.navigation.items.images': 'イメージレジストリ',
};
